import { IconDeviceFloppy } from '@tabler/icons-react';
import { cn } from '@/lib/utils';
import { useTranslation } from '../../i18n/hooks/useTranslation';

/**
 * The one Save button for settings screens. It is disabled until something has actually changed (`dirty`)
 * and while the request runs (`saving`, shown as a spinner instead of the disk icon). The label is always
 * the same, "Save" (সেভ করুন), so every Save on the page looks and behaves alike.
 *
 * @param {boolean}  dirty    there are unsaved changes (compare the form with its last saved copy)
 * @param {boolean}  [saving] a save request is in flight
 * @param {Function} onClick  runs the save
 */
export default function SaveButton({ dirty, saving = false, onClick, className, ...rest }) {
    const { t } = useTranslation();
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={!dirty || saving}
            className={cn(
                'inline-flex items-center justify-center gap-1.5 rounded-lg bg-primary px-5 py-2 text-sm font-semibold text-white transition-colors hover:bg-primary/90 disabled:cursor-not-allowed disabled:opacity-50',
                className
            )}
            {...rest}
        >
            {saving
                ? <span className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-white border-t-transparent" />
                : <IconDeviceFloppy size={16} />}
            {t('common.save')}
        </button>
    );
}
